/* Category flyouts: hover, keyboard focus and first-tap expansion. */
(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('.amm-catdrop,.amm-hero__menu').forEach(function (root) {
      if (root.dataset.ammNavigation) return;
      root.dataset.ammNavigation = '1';
      var trigger = root.querySelector(':scope > .deodap-category-btn');
      var panel = root.querySelector(':scope > .amm-catdrop__panel');
      var timer, touch = false;
      function open() {
        clearTimeout(timer);
        delete root.dataset.ammDismissed;
        root.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }
      function close() {
        clearTimeout(timer);
        root.classList.remove('is-open');
        root.dataset.ammDismissed = 'true';
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        root.querySelectorAll('.amm-catdrop__item').forEach(function (item) {
          item.classList.remove('is-open');
          var link = item.querySelector(':scope > a[aria-expanded]');
          if (link) link.setAttribute('aria-expanded', 'false');
        });
      }
      root.addEventListener('pointerdown', function (e) { touch = e.pointerType !== 'mouse'; }, true);
      root.addEventListener('keydown', function () { touch = false; }, true);
      root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { touch = false; open(); } });
      root.addEventListener('pointerleave', function () {
        timer = setTimeout(function () { if (!root.contains(document.activeElement)) close(); }, 160);
      });
      root.addEventListener('focusin', function () { if (!touch) open(); });
      root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) close(); });
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        if (panel) {
          panel.id = panel.id || 'AmmCategories-' + Math.random().toString(36).slice(2, 8);
          trigger.setAttribute('aria-controls', panel.id);
        }
        trigger.addEventListener('click', function (e) {
          if (touch && !root.classList.contains('is-open')) { e.preventDefault(); open(); }
        });
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') {
            e.preventDefault(); open();
            var first = panel && panel.querySelector('a');
            if (first) first.focus();
          }
        });
      }
      root.querySelectorAll('.amm-catdrop__item').forEach(function (item) {
        var link = item.querySelector(':scope > a');
        var sub = item.querySelector(':scope > .amm-catdrop__sub');
        if (!link) return;
        if (sub) { link.setAttribute('aria-haspopup', 'true'); link.setAttribute('aria-expanded', 'false'); }
        function select() {
          open();
          root.querySelectorAll('.amm-catdrop__item').forEach(function (other) {
            var on = other === item && !!sub;
            other.classList.toggle('is-open', on);
            var a = other.querySelector(':scope > a[aria-expanded]');
            if (a) a.setAttribute('aria-expanded', String(on));
          });
        }
        item.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') select(); });
        link.addEventListener('focus', function () { if (!touch) select(); });
        if (!sub) return;
        link.addEventListener('click', function (e) {
          if (touch && !item.classList.contains('is-open')) { e.preventDefault(); select(); }
        });
        link.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); select(); var a = sub.querySelector('a'); if (a) a.focus(); }
        });
        sub.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); link.focus(); } });
      });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); if (trigger) trigger.focus(); close(); }
      });
      document.addEventListener('pointerdown', function (e) { if (!root.contains(e.target)) close(); });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('error', function (e) {
    var img = e.target;
    if (img.tagName === 'IMG' && img.dataset.ammFallback && !img.dataset.ammRetried) {
      img.dataset.ammRetried = '1'; img.src = img.dataset.ammFallback;
    }
  }, true);
  document.querySelectorAll('img[data-amm-fallback]').forEach(function (img) {
    if (img.complete && img.naturalWidth === 0) img.dispatchEvent(new Event('error'));
  });
})();
